/*
*
* Example of setting up the object to pass into the DataTable component
*
* const tableHeaders = [
*     'Column 1',
*     'Column 2',
*     'Column 3'
* ]
*
*
* const formattedListToDisplay = [
*     [
*       {
*           content: this.aMethodThatOutputsJSX.bind(this, row),
*           type: 'render'
*       },
*       {
*           content: 'Some String Of Text'
*       },
*       {
*           content: '<a href="#">Some Formatted HTML</a>',
*           type: 'html'
*       },
*    ],
*    [
*       {
*           content: this.aMethodThatOutputsJSX.bind(this, row),
*           type: 'render'
*       },
*       {
*           content: 'Some String Of Text'
*       },
*       {
*           content: '<a href="#">Some Formatted HTML</a>',
*           type: 'html'
*       },
*   ]
* ]
*
* const formattedListToDisplay = {
*    headers: tableHeaders,
*    rows: formattedListToDisplay
* }
*
*
* Exmaples of implementing the DataTable Component JSX
*
* // With custom Add New button text
* <DataTable
*     list={this.state.formattedListToDisplay}
*     onDelete={this.handleRowDelete}
*     onEdit={this.handleEdit}
*     onNew={{
*         callback: this.handleNew,
*         text: 'Add New Contact',
*     }}
* />
*
* // No Add New custom text (default text is `+Add`);
* <DataTable
*     list={this.state.formattedListToDisplay}
*     onDelete={this.handleRowDelete}
*     onEdit={this.handleEdit}
*     onNew={this.handleNew}
* />
*
*
* // To add a temporary placeholder for your DataTable
* <DataTable />
*
*/

import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faEdit, faGripVertical, faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from 'reactstrap';




export interface IList {
    headers: any[];
    rows: any[];
}

interface IOnNew {
    callback: any;
    text: string;
}

interface IDefaultSort {
    index: number;
    name: string;
    change: any;
}

interface IDataTable {
    list: IList;
    headerButtons?: any[];
    loading?: boolean;
    maxHeight?: string;
    multiSelectChecked?: boolean[];
    onEdit?: any;
    onDelete?: any;
    onMultiSelect?: any;
    onNew?: IOnNew | any;
    onReorder?: any;
    onSelect?: any;
    sortable?: boolean;
    defaultSort?: IDefaultSort;
    varWidths?: boolean;
    delibleList?: boolean[];
    disableEditing?: boolean;
}

class DataTable extends React.Component {

    public props: IDataTable;
    public list: IList;
    private contactIndex: number = -1;
    private guid: string;

    public state = {
        contactIndex: this.contactIndex,
        list: this.list,
        removeRowModal: false,
        sortColumnIndex: -1,
        sortOrder: 0,
    };

    constructor(props: IDataTable) {
        super(props);
        this.guid = getGuid();
    }

    private renderHeader(header: any, index: string | number, colWidth?: number) {
        let val = '';

        if ( typeof header !== 'object' ) {
            val = header;

        } else {
            const cls = 'sortable ' + (header.class || '');
            const type = header.type || '';
            const paramWidth = header.width ? header.width : colWidth;
            switch(type) {
                case 'html' :
                    return (
                        <th
                            onClick={this.sortColumnHeader}
                            className={cls} key={'dt-header-' + index} dangerouslySetInnerHTML={{__html: header.content}} />
                    );

                case 'render' :
                        return(
                            <th 
                            onClick={this.sortColumnHeader}
                            style={ paramWidth ? {width : paramWidth + '%'} : {}}
                            className={cls} key={'dt-header-' + index}><header.content/></th>
                        );
                default :
                    return (
                        <th 
                            onClick={this.sortColumnHeader}
                            style={ paramWidth ? {width : paramWidth + '%'} : {}}
                            className={cls} key={'dt-header-' + index}>{header.content}</th>
                    );
            }
        }

        return(
            <th 
                className="sortable" 
                onClick={this.sortColumnHeader} 
                style={ colWidth ? {width : colWidth + '%'} : {}}
                key={'dt-header-' + index}
            >
                {val}
            </th>
        );
    }

    private renderHeaderButtons = (header: any, index: number) => {
        let val = '';

        if (header === undefined) {
            return (
                <th 
                style={val ? {padding: '0px'} : {}}
                key={'dt-header-button' + index}
            >
                {val}
            </th>
            );
        }
        if ( typeof header !== 'object') {
            val = header;
        } else {
            const cls = header.cls || '';
            const type = header.type || '';
            switch(type) {
                case 'html' :
                    return (
                        <th
                            className={cls}
                            key={'dt-header-button' + index} dangerouslySetInnerHTML={{__html: header.content}} />
                    );

                case 'render' :
                        return(
                        <th
                            className={cls}
                            style={{padding: '0px'}}
                            key={'dt-header-button' + index}><header.content/></th>
                        );
                default :
                    return (
                        <th 
                            className={cls}
                            key={'dt-header-button' + index}>{header.content}</th>
                    );
            }
        }

        return(
            <th 
                style={val ? {padding: '0px'} : {}}
                key={'dt-header-button' + index}
            >
                {val}
            </th>
        );
    }

    private renderTableCell(cell: any, index: string | number, indexY: number, rowLength: number) {
        let val = '';

        if ( typeof cell !== 'object' ) {
            val = cell;
        } else {
            const cls = cell.class || '';
            const type = cell.type || '';

            switch(type) {
                case 'html' :
                    return (
                        <td className={cls} key={'dt-cell-' + index + '-' + indexY + this.guid} dangerouslySetInnerHTML={{__html: cell.content}} />
                    );

                case 'render' :
                    return(
                        <td className={cls} key={'dt-cell-' + index + '-' + indexY + this.guid}>{cell.content(rowLength * indexY + Number(index))}</td>
                    );

                case 'defaultSort':
                    return '';
                default :
                    return (
                        <td className={cls} key={'dt-header-' + index + '-' + indexY + this.guid}>{cell.content}</td>
                    );
            }
        }

        return(
            <td key={'dt-cell-' + index + '-' + indexY + this.guid}>{val}</td>
        );
    }

    private toggleRemoveModal = (contactIndex?: number) => () =>{
        if ( typeof contactIndex !== 'undefined' ) {
            this.setState({
                contactIndex,
                removeRowModal: !this.state.removeRowModal
            });
        } else {
            this.setState({
                removeRowModal: !this.state.removeRowModal
            });
        }
    }

    private confirmedRemove = () => {
        if ( this.props.onDelete ) {
            const sortedArray = this.props.list.rows.slice().sort(this.sortFunction);
            const item = sortedArray[this.state.contactIndex];
            const myIndex = this.props.list.rows.indexOf(item);
            this.props.onDelete(myIndex);
        }

        this.toggleRemoveModal()();
    }

    private handleSelect = (contactIndex: number) => () => {
        if ( this.props.onSelect ) {
            const sortedArray = this.props.list.rows.slice().sort(this.sortFunction);
            const item = sortedArray[contactIndex];
            const myIndex = this.props.list.rows.indexOf(item);
            this.props.onSelect(myIndex);
        }
    }

    private multiSelectIsChecked = (contactIndex: number) => {
        if (this.state.sortOrder !== 0) {
            const sortedArray = this.props.list.rows.slice().sort(this.sortFunction);
            const item = sortedArray[contactIndex];
            const myIndex = this.props.list.rows.indexOf(item);
            return this.props.multiSelectChecked && this.props.multiSelectChecked[myIndex];
        } else {
            return this.props.multiSelectChecked && this.props.multiSelectChecked[contactIndex];
        }
    }
    private handleMultiSelect = (contactIndex: number) => () => {
        if ( this.props.onMultiSelect ) {
            if (this.state.sortOrder !== 0) {
                const sortedArray = this.props.list.rows.slice().sort(this.sortFunction);
                const item = sortedArray[contactIndex];
                const myIndex = this.props.list.rows.indexOf(item);
                this.props.onMultiSelect(myIndex);
            } else {
                this.props.onMultiSelect(contactIndex);
            }
        }
    }

    private handleSetDefaultSort = () => {
        if (this.props.defaultSort) {
            const sortedArray = this.props.list.rows.slice().sort(this.sortFunction);
            const unsortedArray = this.props.list.rows.slice();
    
            const sortOrder = unsortedArray.map(val => sortedArray.indexOf(val));
            
            const table: any = document.getElementById(this.guid);
            //
            // This goes through and adds/removes classes based on sorting
            // This will help identify which column is sorted and in what order
            if ( table !== null ) {
                const tbody: any = document.getElementById("tableBody" + this.guid);
                const ths: any = table.getElementsByTagName('th');
                const tds: any = tbody.getElementsByTagName('td');
                
                for ( const th of ths ) {
                    th.classList.remove('asc', 'desc');
                }
    
                for ( const td of tds ) {
                    td.classList.remove('sorted');
                }
            }
            this.setState({
                sortColumnIndex: -1,
                sortOrder: 0,
            });
            this.props.defaultSort.change(sortOrder, this.props.defaultSort.name);
        }
    }

    private handleEdit = (contactIndex: number) => () => {
        if ( this.props.onEdit ) {
            if (this.state.sortOrder !== 0) {
                const sortedArray = this.props.list.rows.slice().sort(this.sortFunction);
                const item = sortedArray[contactIndex];
                const myIndex = this.props.list.rows.indexOf(item);
                this.props.onEdit(myIndex);
            } else {
                this.props.onEdit(contactIndex);
            }
        }
    }

    private handleNew = () => {
        if ( this.props.onNew ) {
            this.props.onNew.callback();
        }
    }

    private onDragEnd = (result: any) => {
        if (!result.destination) {
            return;
        }

        if (!this.props.onReorder ) {
            return;
        }
        this.props.onReorder(result.source.index, result.destination.index);
    }

    public sortColumnHeader = (event:any) => {
        const table: any = document.getElementById(this.guid);

        //
        // This goes through and adds/removes classes based on sorting
        // This will help identify which column is sorted and in what order
        if ( table !== null ) {
            const tbody: any = document.getElementById("tableBody" + this.guid);
            const ths: any = table.getElementsByTagName('th');
            const tds: any = tbody.getElementsByTagName('td');
            
            for ( const th of ths ) {
                th.classList.remove('asc', 'desc');
            }

            for ( const td of tds ) {
                td.classList.remove('sorted');
            }

            let newSortOrder;
            switch(this.state.sortOrder) {
                case -1:
                    newSortOrder = 0;
                    break;
                case 0:
                    newSortOrder = 1;
                    event.target.classList.add('asc');
                    break;
                case 1:
                    newSortOrder = -1;
                    event.target.classList.add('desc');
                    break;
                default:
                    newSortOrder = 0;
                    break;
            }
            if (newSortOrder !== 0) {
                for ( const row of tbody.rows ) {
                    row.cells[event.target.cellIndex].classList.add('sorted');
                }
            }
            let offsetIndex = this.props.onEdit ? 1 : 0;
            if (this.props.onMultiSelect) {
                offsetIndex++;
            }
            this.setState({
                sortColumnIndex: event.target.cellIndex - offsetIndex,
                sortOrder: newSortOrder,
            });
        }
    }
    private sortFunction = (a: any, b: any) => {
        let offsetIndex = this.props.onEdit ? 1 : 0;
        if (this.props.onMultiSelect) {
            offsetIndex++;
        }
        const index = this.state.sortColumnIndex < 0 ? (this.props.defaultSort !== undefined ? this.props.defaultSort.index - offsetIndex : -1) : this.state.sortColumnIndex;
        let order = this.state.sortOrder;
        if (this.props.defaultSort !== undefined && order === 0) {
            order = 1;
        }
        if (index < 0 || order === 0) {
            return 0;
        }
        const aContent = a[index].sortItem !== undefined ? a[index].sortItem : a[index].content;
        const bContent = b[index].sortItem !== undefined ? b[index].sortItem : b[index].content;
        // console.log(`aContent: ${aContent} bContent: ${bContent}`);
        if (aContent === bContent) {
            return 0;
        } else if (aContent === '') {
            return 1;
        } else if(bContent === '') {
            return -1;
        }
        if (typeof aContent === 'string' 
            && ( isNaN(Number(aContent))) || aContent === '' ) {
            return aContent.localeCompare(bContent) * order;
        } else if (typeof aContent === 'number' || !isNaN(Number(aContent))) {
            return (Number(aContent) - Number(bContent)) * order;
        } else if (typeof aContent === 'boolean') {
            return (aContent === bContent ? 0 : aContent ? -1 : 1) * order;
        } else {
            return 0;
        }

    }

    private delibleIndex = (index: number) => {
        const sortedArray = this.props.list.rows.slice().sort(this.sortFunction);
        const item = sortedArray[index];
        const myIndex = this.props.list.rows.indexOf(item);
        return myIndex;
    }

    private spinnerIcon = () => {
        return (
            <FontAwesomeIcon 
                icon={faSpinner}
                spin={true}
                size={"8x"}
                style={{position: 'fixed', left: '50%', top: '35%'}}
            />
        );
    }
    public render() {
        const headerRow = this.props.headerButtons ? this.props.headerButtons.slice() : undefined;
        if (headerRow && this.props.list) {
            while (headerRow.length < this.props.list.headers.length) {
                headerRow.push(undefined);
            }
        }

        if (!this.props.list) {
            return this.spinnerIcon();
        }
        const tableWidth = this.props.varWidths ? undefined : (this.props.list.headers.length > 0 ? 100 / this.props.list.headers.length : undefined);
        if (this.props.loading || (this.props.list.headers 
            && this.props.list.headers.length === 0 
            && this.props.list.rows
            && this.props.list.rows.length === 0)) {
            return this.spinnerIcon();
        }
        const maxHeight = this.props.maxHeight ? this.props.maxHeight : '70vh';
        const delibleArr = this.props.delibleList;
        return(
            <div className="data-table-component">
                {
                    this.props.defaultSort && this.props.defaultSort.change &&
                    <div style={{textAlign: 'right', marginBottom: '10px', marginRight: '10px'}}>
                        <Button className="secondary" color="secondary" onClick={this.handleSetDefaultSort}>Set Sort Order</Button>
                    </div>
                }
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable" isDropDisabled={!this.props.onReorder}>
                        {(provided: any, snapshot: any) => (
                        <div ref={provided.innerRef} className="scroll-wrapper" style={{maxHeight}}>
                            <Table className="sortableTable" id={this.guid}>
                                <thead className="stickyHeader">
                                    <tr>
                                        {this.props.sortable &&
                                            <th>&nbsp;</th>
                                        }
                                        {this.props.onMultiSelect &&
                                            <th>&nbsp;</th>
                                        }
                                        {this.props.onEdit && !this.props.disableEditing &&
                                            <th>&nbsp;</th>
                                        }
                                        {this.props.list.headers.map((column: string, index: number) =>
                                            this.renderHeader(column, index, tableWidth)
                                            )}
                                        {this.props.onDelete && !this.props.disableEditing &&
                                            <th>&nbsp;</th>
                                        }
                                    </tr>
                                {
                                    headerRow &&
                                    <tr className="header-button-row">
                                        {this.props.sortable &&
                                            <th>&nbsp;</th>
                                        }
                                        {this.props.onMultiSelect &&
                                            <th>&nbsp;</th>
                                        }
                                        {this.props.onEdit && !this.props.disableEditing &&
                                            <th>&nbsp;</th>
                                        }
                                        {headerRow.map((column: string, index: number) =>
                                            this.renderHeaderButtons(column, index)
                                            )}
                                        {this.props.onDelete && !this.props.disableEditing &&
                                            <th>&nbsp;</th>
                                        }
                                    </tr>
                                }
                                </thead>
                                <tbody id={"tableBody" + this.guid}>
                                    { this.props.list.rows.slice().sort(this.sortFunction).map((row: any, index: number) =>
                                        row.length > 0 &&
                                        <Draggable key={"someid" + index + this.guid} draggableId={"someid" + index + this.guid} index={index} isDragDisabled={!this.props.onReorder || this.state.sortOrder !== 0}>
                                        {(provided2: any, snapshot2: any) => {
                                        const style = {
                                            cursor: 'pointer',
                                            ...provided2.draggableProps.style
                                        };
                                        return (

                                            <tr
                                                ref={provided2.innerRef}
                                                key={'dt-row-' + index + '-' + this.guid}
                                                {...provided2.draggableProps}
                                                {...provided2.dragHandleProps}
                                                onClick={this.props.onSelect && this.handleSelect(index)}
                                                style={this.props.onSelect ? style : {...provided2.draggableProps.style}}
                                            >
                                                {this.props.sortable &&
                                                    <td>
                                                        <div className="drag-handle">
                                                            <FontAwesomeIcon icon={faGripVertical} />
                                                        </div>
                                                    </td>
                                                }
                                                {this.props.onMultiSelect &&
                                                    <td>
                                                        <div className="multi-select-row">
                                                            <Input
                                                                key={'check-' + JSON.stringify(row).substring(0, 20)}
                                                                className="multi-select-check"
                                                                onChange={this.handleMultiSelect(index)}
                                                                type="checkbox"
                                                                value=""
                                                                checked={this.multiSelectIsChecked(index)}
                                                            />
                                                        </div>
                                                    </td>
                                                }
                                                {this.props.onEdit && !this.props.disableEditing &&
                                                    <td>
                                                        <div className="edit-row" onClick={this.handleEdit(index)}>
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </div>
                                                    </td>
                                                }
                                                { row.map((val: any, i: number) =>
                                                    this.renderTableCell(val, index, i, this.props.list.rows.length)
                                                    )}
                                                {this.props.onDelete && !this.props.disableEditing &&
                                                    <td>
                                                        {
                                                            delibleArr ?
                                                            delibleArr[this.delibleIndex(index)] &&
                                                            <div className="remove-row" onClick={this.toggleRemoveModal(index)}>
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </div>
                                                            :
                                                            <div className="remove-row" onClick={this.toggleRemoveModal(index)}>
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </div>
                                                        }
                                                    </td>
                                                }
                                            </tr>
                                        );}}
                                        </Draggable>
                                    ) }
                                </tbody>
                                {provided.placeholder}
                            </Table>
                        </div>
                        )}
                    </Droppable>
                </DragDropContext>
                {this.props.onNew && !this.props.disableEditing &&
                    <div className="add-table-row">
                        <Button color="primary" className="add-new-button" onClick={this.handleNew}>
                            <FontAwesomeIcon icon={faPlus} />
                            {' '}
                            {this.props.onNew.text ? (
                                this.props.onNew.text
                                ) : (
                                    'Add'
                                    )}
                        </Button>
                    </div>
                }

                {/*
                    Remove Contact Modal
                */}
                <Modal isOpen={this.state.removeRowModal} toggle={this.toggleRemoveModal.bind(this, this.state.contactIndex)}>
                    <ModalHeader>Remove Row</ModalHeader>
                    <ModalBody>Are you sure you want to remove this row?</ModalBody>
                    <ModalFooter>
                        <Button
                            className="secondary"
                            onClick={this.toggleRemoveModal(undefined)}
                        >
                            No
                        </Button>
                        {' '}
                        <Button
                            color="primary"
                            id="addAnother"
                            onClick={this.confirmedRemove}
                        >
                            Yes
                        </Button>
                    </ModalFooter>
                </Modal>
                {/*
                    Remove Contact Modal
                */}
            </div>
        );
    }

}
const getGuid = () => {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()).replace(/-/g, '');
  };
export default DataTable;



// WEBPACK FOOTER //
// ./src/Components/DataTable/DataTable.tsx